import { tns } from 'tiny-slider';

export default function initMinigallery(nodeList) {
  let galleries = document.querySelectorAll('.package-minigallery');

  if (nodeList instanceof NodeList) {
    galleries = nodeList;
  }

  if (!galleries.length) {
    return;
  }

  const onChange = function (info) {
    const currentItem = info.slideItems[info.index];
    const img = currentItem.querySelector('img,svg');
    const title = img.getAttribute('title') ? img.getAttribute('title') : '';
    info.controlsContainer.setAttribute('title', title);
  };

  galleries.forEach(galleryWrap => {
    const gallery = galleryWrap.querySelector(':scope > div');
    const trackId = galleryWrap.dataset.galleryTrackId ?? null;
    let slider = null;
    if (gallery) {
      slider = tns({
        container: gallery,
        items: 1,
        slideBy: 'page',
        autoplay: false,
        controlsPosition: 'bottom',
        nav: true,
        navPosition: 'bottom',
        controlsText: ['', ''],
        onInit: onChange,
      });
    }

    slider.events.on('indexChanged', onChange);

    if (trackId && slider) {
      window.galleries = window.galleries || {};
      window.galleries[trackId] = slider;
    }
  });
}
